export default __webpack_public_path__ + "static/media/EPCL.81e9196d.svg";